import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faBolt,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./Commitment.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const commitmentData = [
  {
    icon: faBullseye,
    title: "Transparent",
    description:
      "Complete transparency at every step. You know exactly where you stand and what to expect next.",
  },

  {
    icon: faBolt,
    title: "Efficient",
    description:
      "Streamlined process with minimal delays. Average placement time: 2-3 months from application.",
  },

  {
    icon: faShieldAlt,
    title: "Legal & Safe",
    description:
      "100% legal compliance with MEA regulations. Your safety and rights are our top priority.",
  },
];

function CommitmentSection() {
  return (
    <section className="commitment_section">
      <Container>
        <Row className="commitment_heading">
          <CommonHeading badge="commitment" title="Our Commitment to You" />
        </Row>

        <Row className="g-5">
          {commitmentData.map((item, index) => (
            <Col key={index} xs={12} md={4} >
              <div className="commitment_card">
                <div className="commitment_icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <h3 className="commitment_card_title">{item.title}</h3>

                <p className="commitment_card_description">
                  {item.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default CommitmentSection;
